<template>
  <div class="wrap">
    <ul>
      <li v-for="(i,index) in listS.left" :key="index">
        <a :href="'gylDetails.html?id=' + i.id">
          <img :src="i.thumbnailImage">
          <div class="info">
            <div class="name hidden_tetx_two">{{i.name}}</div>
            <div class="marketPrice">市场价: {{i.marketPrice}}</div>
            <div class="costPrice">成交价: {{i.costPrice}}
              <div class="" v-if="i.costPrice === '***'"><a>(登录查看)</a></div>
            </div>
          </div>
        </a>
      </li>
    </ul>
    <ul>
      <li v-for="(i,index) in listS.right" :key="index">
        <a :href="'gylDetails.html?id=' + i.id">
          <img :src="i.thumbnailImage">
          <div class="info">
            <div class="name hidden_tetx_two">{{i.name}}</div>
            <div class="marketPrice">市场价: {{i.marketPrice}}</div>
            <div class="costPrice">成交价: {{i.costPrice}}
              <div class="" v-if="i.costPrice === '***'"><a>(登录查看)</a></div>
            </div>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'commodity',
  props: {
    list: Array
  },
  data () {
    return {
      listS: []
    }
  },
  watch: {
    'list': function () {
      let commodityData = {left: [], right: []}
      for(let i = 0;i<this.list.length;i++) {
        let item = this.list[i]
        if (i%2 === 0){
          commodityData.left.push(item)
        } else {
          commodityData.right.push(item)
        }
      }
      this.listS = commodityData
    }
  },
  methods: {
  }
}
</script>
<style lang="stylus" scoped>
.wrap
  display flex
  padding 0 px(20)
  justify-content space-between
  background #f8f8f8
  overflow auto
  ul
    width 48%
    li
      background #fff
      margin-bottom px(20)
      img
        width 100%
      .info
        padding px(20) px(16)
        .name
          color #333
          font-size px(26)
        .marketPrice,.costPrice
          font-size px(24)
          color #D22016
          margin px(6) 0
          display flex
          a
            width auto
            height auto
            color #D22016
</style>



// WEBPACK FOOTER //
// src/components/gyl/commodity.vue